import { api } from './api';
import type { AuthUser } from '../types/api';

export const authApi = {
  register: (input: { email: string; password: string; realName?: string; institution?: string }) =>
    api.post<{ user: AuthUser; accessToken: string }>('/auth/register', input),
  login: (input: { email: string; password: string }) =>
    api.post<{ user: AuthUser; accessToken: string }>('/auth/login', input),
  refresh: () => api.post<{ user: AuthUser; accessToken: string }>('/auth/refresh'),
  logout: () => api.post('/auth/logout'),
  me: () => api.get<{ user: AuthUser }>('/auth/me'),
  smsSend: (b: { phone: string; purpose: 'register' | 'login' | 'bind' | 'reset' }) =>
    api.post<{ ok: true }>('/auth/sms/send', b),
  registerPhone: (b: { phone: string; code: string; password?: string; email?: string; acceptPrivacy: boolean; privacyVersion: number }) =>
    api.post<{ user: AuthUser; accessToken: string }>('/auth/register-phone', b),
  loginPhone: (b: { phone: string; code: string }) =>
    api.post<{ user: AuthUser; accessToken: string }>('/auth/login-phone', b),
  bindPhone: (b: { phone: string; code: string; acceptPrivacy: boolean; privacyVersion: number }) =>
    api.post<{ user: AuthUser }>('/auth/bind-phone', b),
  resetPasswordByPhone: (b: { phone: string; code: string; newPassword: string }) =>
    api.post<{ ok: true }>('/auth/reset-password-by-phone', b),
  policyVersion: () =>
    api.get<{ privacyPolicyVersion: number; effectiveDate: string; phoneVerifyEnabled: boolean }>(
      '/auth/policy-version',
    ),
};
